module.exports = "<canvas #canvas></canvas>\n<img #img />"


//////////////////
// WEBPACK FOOTER
// ./src/app/assessment-charts/legend-color-icon/legend-color-icon.component.html
// module id = ./src/app/assessment-charts/legend-color-icon/legend-color-icon.component.html
// module chunks = main